import { render, staticRenderFns } from "./report_stu_zhushou_new_move.vue?vue&type=template&id=3a480ee0&scoped=true&"
import script from "./report_stu_zhushou_new_move.vue?vue&type=script&lang=js&"
export * from "./report_stu_zhushou_new_move.vue?vue&type=script&lang=js&"
import style0 from "./report_stu_zhushou_new_move.vue?vue&type=style&index=0&id=3a480ee0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a480ee0",
  null
  
)

export default component.exports